<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Event & Tips</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  v-model.trim="corporateActionDataNew.corporate_action_title"
                  label="Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  :is-valid="corporateActionData.corporate_action_title && corporateActionData.corporate_action_title.length > 65 ? false : null"
                  invalid-feedback="Title more than 65 characters"
                  @change="handleCorporateActionTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="corporate_slug"
                  label="Url Name"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Url Name"
                  v-model.trim="corporateActionDataNew.corporate_action_slug"
                  @change="handleCorporateActionSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Description"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Description"
                  v-model="corporateActionDataNew.meta_info_description"
                  @change="handleMetaDescription"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Keyword"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Meta Keyword"
                  v-model="corporateActionDataNew.meta_info_keyword"
                  @change="handleMetaKeyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Jenis Article"
                  :options="options"
                  required
                  horizontal
                  v-model="corporateActionDataNew.corporate_action_type"
                  @change="handleCorporateActionType"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Bahasa"
                :options="optionsLanguage"
                required
                horizontal
                placeholder="Pilih"
                v-model="corporateActionDataNew.language"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Author</label>
                <div class="col-sm-9" style="z-index: 2;">
                  <multiselect
                      horizontal
                      v-model="author"
                      :options="optionsAuthor"
                      label="author_name"
                      track-by="author_name"
                      placeholder="Select author"
                      :multiple="false"
                      @change="handleAuthor"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Active Date"
                  class="mb-0"
                  type="datetime-local"
                  required
                  horizontal
                  placeholder="Active Date"
                  v-model.trim="corporateActionDataNew.active_date"
                  @change="handleActiveDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group mt-5">
            <CCol :col="12">
              <a>Content</a>
              <editor
                  id="editor"
                  :api-key="key"
                  :init="initOption"
                  v-model="corporateActionDataNew.corporate_action_content"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Ilustrasi di perlukan
              </div>
              <CInputFile
                  label="File Illustration"
                  horizontal
                  type="file"
                  :is-valid="false"
                  :invalid-feedback="error.attachment_corporate_action_photo_url.message"
                  @change="readURL"
              >
                <template v-slot:label-after-input>
                  File size should be below 250KB and Optimize picture size is 980px x 400px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Illustration"
                  v-model="corporateActionDataNew.alt_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                  label="File Sub Illustration"
                  horizontal
                  type="file"
                  :isValid="false"
                  :invalidFeedback="error.attachment_corporate_action_sub_photo_url.message"
                  @change="handleCorporateActionSubPhotoUrl"
              >
                <template v-slot:label-after-input>
                  File size should be below 150KB and Optimize picture size is 300px x 200px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="subPhotoUrl" :src="subPhotoUrl"/>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="ALT Sub Illustration"
                  class="mb-0"
                  type="text"
                  horizontal
                  placeholder="ALT Sub Illustration"
                  v-model="corporateActionDataNew.alt_sub_photo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Hashtag</label>
                <div class="col-sm-9">
                  <multiselect
                      horizontal
                      v-model="corporateActionDataNew.corporate_action_hashtag_ids"
                      :options="optionsHashtag"
                      :multiple="true"
                      @change="handleHashtagCorporateAction">
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Category</label>
                <div class="col-sm-9">
                  <multiselect
                      horizontal
                      :value="selectedArticleCategories"
                      :options="optionsArticleCategories"
                      label="name"
                      track-by="id"
                      :multiple="true"
                      @input="handleArticleCategoriesChange"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show in related Event & Tips?"
                  :options="optionsShowRelated"
                  required
                  horizontal
                  v-model="corporateActionDataNew.corporate_action_related_show_option"
                  @change="handleShowRelatedCorporateAction"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Article Info"
                  :options="optionsArticleInfo"
                  required
                  horizontal
                  v-model="corporateActionData.article_info"
                  @change="handleShowArticleInfo"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Suggestion Article"
                  :options="optionsSuggestionArticle"
                  required
                  horizontal
                  v-model="corporateActionData.is_suggested"
                  @change="handleShowIsSuggested"
              />
            </CCol>
          </CRow>
          <CRow class="form-group"
                v-if="visiblePriority">
            <CCol :col="8">
              <CInput
                  id="corporate_priority"
                  type="number"
                  min="1"
                  max="5"
                  label="Priority"
                  class="mb-0"
                  horizontal
                  placeholder="Priority 1–5"
                  v-model="corporateActionData.priority"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  horizontal
                  v-model="corporateActionDataNew.status"
                  @change="handleStatusCorporateAction"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="Show Section POS Interpack"
                  :options="optionsShowSectionPOSInterpack"
                  required
                  horizontal
                  v-model="corporateActionDataNew.show_pos_interpack"
                  @change="handleShowSectionPOSInterpack"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="corporateActionData.article_info === 'NEWS'">
            <CCol :col="8">
              <CSelect
                  label="Category"
                  :options="optionsCategory"
                  v-model="corporateActionDataNew.corporate_action_category_id"
                  horizontal
                  :required="corporateActionData.article_info === 'NEWS'"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                  label="FAQ Status"
                  :options="optionsFaqStatus"
                  required
                  horizontal
                  v-model="corporateActionDataNew.faq_status"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <div class="mb-2">
                <strong>FAQ</strong>
              </div>
              <DynamicCrudTable
                  title=""
                  v-model="faqs"
                  :columns="faqColumns"
                  :max-rows="6"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="8">
              <div role="group" class="form-group form-row">
                <label class="col-form-label col-sm-3">Like & Comment</label>
                <div class="col-sm-9">
                  <multiselect
                    v-model="likeCommentSelection"
                    :options="optionsLikeComment"
                    :multiple="true"
                  >
                  </multiselect>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  :disabled="isSubmitting"
                  @click="updateCorporateAction"
              >{{ isSubmitting ? "Submitting..." : "Submit" }}
              </CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody v-if="hasCommentArticleId" class="comment-list-card-body">
          <h5>List Comment</h5>
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Comment</th>
                  <th>Status</th>
                  <th>Created by</th>
                  <th>Created Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="comment in comments" :key="comment.comment_id">
                  <td class="comment-text">{{ comment.comment }}</td>
                  <td>
                    <span :class="['comment-status', commentStatusClass(comment.status)]">
                      {{ formatCommentStatus(comment.status) }}
                    </span>
                  </td>
                  <td>{{ comment.created_by }}</td>
                  <td>{{ formatCommentDate(comment.created_at) }}</td>
                  <td>
                    <div class="comment-action">
                      <button
                        type="button"
                        class="comment-action-toggle"
                        aria-label="Action"
                        aria-haspopup="menu"
                        :aria-expanded="commentActionMenuId === comment.comment_id"
                        :disabled="moderatingCommentId !== null || isLoadingComments"
                        @click.stop="toggleCommentActions(comment.comment_id)"
                      >
                        <CIcon name="cil-options" />
                      </button>
                      <div
                        v-if="commentActionMenuId === comment.comment_id"
                        class="comment-action-menu"
                        role="menu"
                      >
                        <button
                          v-if="['PENDING', 'REJECTED'].includes(String(comment.status).toUpperCase())"
                          type="button"
                          role="menuitem"
                          :disabled="moderatingCommentId !== null || isLoadingComments"
                          @click.stop="moderateComment(comment, 'APPROVED')"
                        >
                          <CIcon name="cil-check" class="comment-action-icon comment-action-icon--approve" />
                          Approve
                        </button>
                        <button
                          v-if="['PENDING', 'APPROVED'].includes(String(comment.status).toUpperCase())"
                          type="button"
                          role="menuitem"
                          :disabled="moderatingCommentId !== null || isLoadingComments"
                          @click.stop="moderateComment(comment, 'REJECTED')"
                        >
                          <CIcon name="cil-x" class="comment-action-icon comment-action-icon--reject" />
                          Reject
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="commentPagination.total_all_item > commentPagination.per_page"
            class="pagination-nav comment-pagination-nav"
          >
            <button
              type="button"
              class="pagination-btn-refresh"
              :disabled="isLoadingComments || moderatingCommentId !== null"
              @click="getComments(1)"
            >Refresh</button>
            <button
              type="button"
              class="pagination-btn-back"
              :disabled="isLoadingComments || moderatingCommentId !== null || commentPagination.page <= 1"
              @click="getComments(commentPagination.page - 1)"
            >back</button>
            <span class="pagination-page-title">{{ commentPagination.page }}</span>
            <button
              type="button"
              class="pagination-btn-next"
              :disabled="isLoadingComments || moderatingCommentId !== null || commentPagination.page * commentPagination.per_page >= commentPagination.total_all_item"
              @click="getComments(commentPagination.page + 1)"
            >next</button>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import Multiselect from 'vue-multiselect'
import {validateImageHeightAndWidth} from "./helper";
import initTinymce from "@/app/constants/initTinymce";
import DynamicCrudTable from "@/components/DynamicCrudTable.vue";

export default {
  name: "CorporateActionEdit",
  beforeRouteEnter(to, from, next) {
    const isRestricted =
        localStorage.getItem("isRestrictedCorporate") === "true";

    if (isRestricted) {
      next("/dashboard");
    } else {
      next((vm) => {
        vm.usersOpened = from.fullPath.includes("usercreate");
      });
    }
  },
  components: {
    editor: Editor,
    Multiselect,
    DynamicCrudTable
  },
  data() {
    return {
      corporateActionDataNew: {},
      corporateActionData: {},
      author: {
        author_id: null,
        author_name: '',
      },
      imageIs: "ADA",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionsAuthor: [],
      options: ["Event", "Tips"],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      optionsShowSectionPOSInterpack: [{value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
      optionsHashtag: [],
      optionsArticleCategories: [],
      selectedArticleCategories: [],
      articleSemuaCategory: null,
      optionsCategory: [],
      optionsHashtag2: ["ACTIVE", "INACTIVE", "test", "test2"],
      optionsShowRelated: ["YES", "NO", "ALWAYS SHOW"],
      optionsArticleInfo: [
        { label: "MITRA", value: "MITRA" },
        { label: "SELLER", value: "SELLER" },
        { label: "BLOG MALAYSIA", value: "BLOG_MALAYSIA" },
        { label: "NEWS", value: "NEWS" }
      ],
      optionsSuggestionArticle: ["YES", "NO"],
      optionsLanguage: [
        { label: "Indonesia", value: "indonesia" },
        { label: "English", value: "english" }
      ],
      faqs: [],
      faqColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "question", label: "Question", type: "text", maxlength: 255 },
        { key: "answer", label: "Answer", type: "textarea" }
      ],
      optionsFaqStatus: [
        { label: "ACTIVE", value: "ACTIVE" },
        { label: "INACTIVE", value: "INACTIVE" }
      ],
      optionsLikeComment: ["Like", "Comment"],
      likeCommentSelection: [],
      comments: [],
      commentPagination: {
        page: 1,
        per_page: 20,
        total_item: 0,
        total_all_item: 0,
      },
      commentActionMenuId: null,
      moderatingCommentId: null,
      isLoadingComments: false,
      url: null,
      alt_photo: "",
      subPhotoUrl: null,
      alt_sub_photo: "",
      arrayPhoto: [],
      initOption: initTinymce.init,
      key: initTinymce.key,
      error: {
        attachment_corporate_action_photo_url: {
          message: ''
        },
        attachment_corporate_action_sub_photo_url: {
          message: ''
        }
      },
      visiblePriority: false,
      isSubmitting: false,
    };
  },
  async mounted() {
    if (!this.authentication()) {
      return;
    }
    this.getAuthor();
    this.getHashtagList();
    await this.getArticleCategoryList();
    await this.getCategoryList();
    await this.getDataByID();
    if (this.hasCommentArticleId) {
      this.getComments(1);
    }

    if (
        this.corporateActionData.article_info === 'NEWS' &&
        !this.corporateActionDataNew.corporate_action_category_id
    ) {
      this.corporateActionDataNew.corporate_action_category_id = 4;
    }
  },

  watch: {
    'corporateActionData.article_info'(newVal) {
      if (newVal === 'NEWS' && !this.corporateActionDataNew.corporate_action_category_id) {
        this.corporateActionDataNew.corporate_action_category_id = 4;
      }
    },
    'corporateActionDataNew.language'(newVal, oldVal) {
      if (typeof newVal === 'string' && newVal && oldVal && newVal !== oldVal) {
        this.corporateActionData.language = newVal;
        this.author = {
          author_id: null,
          author_name: ''
        };
        this.getAuthor(newVal);
      }
    }
  },

  computed: {
    hasCommentArticleId() {
      const articleId = Number(this.$route.params.id);
      return Number.isInteger(articleId) && articleId > 0;
    },
  },
  methods: {
    getCategoryList() {
      axios.get(`${this.domain}/v2/event_and_tips/news/category`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
          .then((response) => {
            this.optionsCategory = response.data.map(item => ({
              value: item.id,
              label: item.name
            }))

            if (this.optionsCategory.length > 0 && !this.corporateActionData.corporate_action_category_id) {
              this.corporateActionData.corporate_action_category_id = this.optionsCategory[0].value;
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.desc?.id || err.message
            });
          });
    },
    getArticleCategoryList() {
      return axios
          .get(`${this.domain}/v1/corporate_action_category/data`, {
            params: {
              status: "ACTIVE",
              per_page: 10000
            },
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const categories = response && response.data && Array.isArray(response.data.data)
                ? response.data.data
                : [];
            this.optionsArticleCategories = categories.map(category => ({
              id: category.id,
              name: category.name
            }));
            this.articleSemuaCategory = this.optionsArticleCategories.find(
                category => category.name === "Semua"
            ) || null;
          })
          .catch((err) => {
            this.optionsArticleCategories = [];
            this.articleSemuaCategory = null;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.message?.id || err.message
            });
          });
    },
    getDataByID() {
      let CorporateActionID = this.$route.params.id;
      return axios
          .get(`${this.domain}/v2/event_and_tips/admin/${CorporateActionID}`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then(async (response) => {
            this.corporateActionDataNew = response.data.data;
            this.corporateActionDataNew.active_date = moment(
                String(this.corporateActionDataNew.active_date)
            ).format("YYYY-MM-DDTHH:mm");

            this.corporateActionData = response.data.data;
            await this.loadSelectedArticleCategories(
                this.corporateActionData.corporate_action_article_category_ids
            );

            if (!this.corporateActionDataNew.language) {
              this.corporateActionDataNew.language = "indonesia";
            }
            if (!this.corporateActionData.language) {
              this.corporateActionData.language = "indonesia";
            }
            
            this.likeCommentSelection = [];
            if (this.corporateActionData.like_enabled === true) {
              this.likeCommentSelection.push("Like");
            }
            if (this.corporateActionData.comment_enabled === true) {
              this.likeCommentSelection.push("Comment");
            }

            this.corporateActionDataNew.faq_status = response.data.data.faq_status || "ACTIVE";
            this.corporateActionData.faq_status = response.data.data.faq_status || "ACTIVE";

            if (response.data.data.faqs && Array.isArray(response.data.data.faqs)) {
              this.faqs = response.data.data.faqs.map(item => ({
                priority: item.priority !== undefined && item.priority !== null ? item.priority : 0,
                question: item.question || "",
                answer: item.answer || ""
              }));
            } else {
              this.faqs = [];
            }

            // ini penting: pakai corporate_action_category_id sebagai default value
            if (this.corporateActionData.corporate_action_category_id) {
              this.corporateActionData.corporate_action_category_id =
                  Number(this.corporateActionData.corporate_action_category_id || 4);
            }

            this.author.author_name = this.corporateActionData.corporate_action_author;
            this.author.author_id = this.corporateActionData.corporate_action_author_id;
            this.getAuthor(this.corporateActionDataNew.language);
            this.corporateActionData.is_suggested = this.corporateActionData.is_suggested
                ? "YES"
                : "NO";
            this.corporateActionData.corporate_action_hashtag_ids =
                this.corporateActionData.corporate_action_hashtag_ids
                    ? this.corporateActionData.corporate_action_hashtag_ids
                        .split(",")
                        .filter((val) => val)
                    : "";

            this.url = this.corporateActionDataNew.attachment_corporate_action_photo_url;
            this.subPhotoUrl =
                this.corporateActionDataNew.attachment_corporate_action_sub_photo_url;

            this.corporateActionData.priority = this.corporateActionData.priority || "";
            this.corporateActionDataNew.priority = this.corporateActionDataNew.priority || "";

            this.$nextTick(() => {
              this.visiblePriority =
                  this.corporateActionData.is_suggested === "YES" &&
                  this.corporateActionData.article_info !== "NEWS";
            });

          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
    async loadSelectedArticleCategories(rawCategoryIDs) {
      const categoryIDs = rawCategoryIDs === null || rawCategoryIDs === undefined || rawCategoryIDs === ""
          ? []
          : String(rawCategoryIDs).split(",").map(id => id.trim()).filter(Boolean);

      const selectedCategories = await Promise.all(categoryIDs.map(async id => {
        const activeCategory = this.optionsArticleCategories.find(
            category => String(category.id) === id
        );
        if (activeCategory) {
          return activeCategory;
        }

        try {
          const response = await axios.get(
              `${this.domain}/v1/corporate_action_category/data/${encodeURIComponent(id)}`,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          );
          const category = response && response.data ? response.data : {};
          if (category.id === undefined || category.id === null || !category.name) {
            return {id, name: String(id)};
          }
          return {id: category.id, name: category.name};
        } catch (error) {
          return {id, name: String(id)};
        }
      }));

      const semuaCategory = this.optionsArticleCategories.find(
          category => category.name === "Semua"
      ) || selectedCategories.find(category => category.name === "Semua") || null;
      this.articleSemuaCategory = semuaCategory;

      const specificCategories = semuaCategory
          ? selectedCategories.filter(category => String(category.id) !== String(semuaCategory.id))
          : selectedCategories;
      if (specificCategories.length > 0) {
        this.selectedArticleCategories = specificCategories;
      } else if (selectedCategories.length > 0) {
        this.selectedArticleCategories = selectedCategories;
      } else {
        this.selectedArticleCategories = semuaCategory ? [semuaCategory] : [];
      }
    },
    getAuthor(language) {
      let lang = typeof language === 'string' ? language : (this.corporateActionDataNew?.language || this.corporateActionData?.language);
      if (typeof lang !== 'string' || !lang) {
        lang = "indonesia";
      }
      axios.get(`${this.domain}/v2/authors/data?page=1&per_page=100&language=${lang}`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
          .then((response) => {
            // JSON responses are automatically parsed.
            const authorsData = (response.data && response.data.data && response.data.data.data) || [];
            this.optionsAuthor = authorsData.map(element => ({
              author_id: element.author_id,
              author_name: element.author_name
            }));
          })
          .catch((err) => {
            if (err.response?.data?.message === "record not found" || err.response?.data?.desc?.id === "record not found") {
              this.optionsAuthor = [];
              return;
            }
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?.data?.desc?.id || err.message
            });
          });
    },
     async getComments(page = this.commentPagination.page) {
      const articleId = Number(this.$route.params.id);
      if (
          !Number.isInteger(articleId) ||
          articleId <= 0 ||
          this.isLoadingComments ||
          this.moderatingCommentId !== null
      ) {
        return;
      }

      this.isLoadingComments = true;
      try {
        const response = await axios.get(
            `${this.domain}/v2/event_and_tips/admin/${articleId}/comments`,
            {
              headers: {
                Authorization: this.token,
              },
              params: {
                page,
                per_page: this.commentPagination.per_page,
              },
            }
        );
        const responseBody = response.data || {};
        const payload = responseBody.data && responseBody.data.pagination
            ? responseBody.data
            : responseBody;
        const pagination = payload.pagination || {};
        const totalItem = Number(pagination.total_item);
        const totalAllItem = Number(pagination.total_all_item);

        this.comments = Array.isArray(payload.data) ? payload.data : [];
        this.commentPagination = {
          page: Number(pagination.page) || page,
          per_page: Number(pagination.per_page) || this.commentPagination.per_page,
          total_item: Number.isFinite(totalItem) ? totalItem : 0,
          total_all_item: Number.isFinite(totalAllItem) ? totalAllItem : 0,
        };
        this.commentActionMenuId = null;
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response?.data?.desc?.id || err.message,
        });
      } finally {
        this.isLoadingComments = false;
      }
    },
    getHashtagList() {
      axios
          .get(`${this.domain}/v1/corporate_action_hashtag/data`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
            params: {
              per_page: 10000,
              status: "ACTIVE"
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            let data = [];
            response.data.data.forEach(element => {
              data.push(
                  element.corporate_action_hashtag_title,
              )
            });
            this.optionsHashtag = data
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.desc.id,
            });
          });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return true;
      } else {
        this.$router.push({path: `/`});
        return false;
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/corporate"});
    },
    handleCorporateActionTitle(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.corporateActionData.corporate_action_slug = slug;
      this.corporateActionData.corporate_action_title = event;
    },
    handleCorporateActionSlug(event) {
      var slug = event
          .replaceAll(/[^A-Za-z0-9 -]/g, "")
          .replaceAll(" ", "-")
          .replaceAll("--", "-")
          .toLowerCase()
          .trim();
      document.getElementById("corporate_slug").value = slug;
      this.corporateActionData.corporate_action_slug = slug;
    },
    handleCorporateActionType(event) {
      this.corporateActionData.corporate_action_type = event.target.value;
    },
    handleAuthor(event) {
      this.author = event;
    },
    handleActiveDate(event) {
      this.corporateActionData.active_date = event.target.value;
    },
    handleCorporateActionContent(event) {
      this.corporateActionData.corporate_action_content = event;
    },
    handleStatusCorporateAction(event) {
      this.corporateActionData.status = event.target.value;
    },
    handleShowRelatedCorporateAction(event) {
      this.corporateActionData.corporate_action_related_show_option = event.target.value;
    },
    handleShowArticleInfo(event) {
      const value = event.target.value;
      this.corporateActionData.article_info = value;

      this.visiblePriority =
          this.corporateActionData.is_suggested === "YES" && value !== "NEWS";
    },
    handleShowIsSuggested(event) {
      const value = event.target.value;
      this.corporateActionData.is_suggested = value;

      this.visiblePriority =
          value === "YES" && this.corporateActionData.article_info !== "NEWS";
    },
    handleShowSectionPOSInterpack(event) {
      this.corporateActionData.show_pos_interpack = event.target.value;
    },
    handleHashtagCorporateAction(event) {
      this.corporateActionData.corporate_action_hashtag_ids = event.target.value;
    },
    handleArticleCategoriesChange(categories) {
      const selectedCategories = Array.isArray(categories) ? categories : [];
      const currentCategories = Array.isArray(this.selectedArticleCategories)
          ? this.selectedArticleCategories
          : [];
      const semuaCategory = this.articleSemuaCategory || this.optionsArticleCategories.find(
          category => category.name === "Semua"
      ) || selectedCategories.find(category => category && category.name === "Semua") || null;

      this.articleSemuaCategory = semuaCategory;
      if (!semuaCategory) {
        this.selectedArticleCategories = selectedCategories;
        return;
      }

      const isSemuaCategory = category =>
          category && String(category.id) === String(semuaCategory.id);
      const addedSemuaCategory =
          selectedCategories.some(isSemuaCategory) && !currentCategories.some(isSemuaCategory);
      const addedSpecificCategory = selectedCategories.some(category =>
          category &&
          !isSemuaCategory(category) &&
          !currentCategories.some(currentCategory =>
              currentCategory && String(currentCategory.id) === String(category.id)
          )
      );

      if (addedSemuaCategory) {
        this.selectedArticleCategories = [semuaCategory];
      } else if (addedSpecificCategory) {
        this.selectedArticleCategories = selectedCategories.filter(category => !isSemuaCategory(category));
      } else {
        this.selectedArticleCategories = selectedCategories;
      }
    },
    handleMetaDescription(event) {
      this.corporateActionData.meta_info_description = event;
    },
    handleMetaKeyword(event) {
      this.corporateActionData.meta_info_keyword = event;
    },
    handleCorporateActionLanguage(event) {
      const lang = typeof event === 'string' ? event : (event && event.target ? event.target.value : null);
      if (typeof lang === 'string' && lang) {
        this.corporateActionData.language = lang;
        this.corporateActionDataNew.language = lang;
      }
    },
    toggleCommentActions(commentId) {
      this.commentActionMenuId = this.commentActionMenuId === commentId ? null : commentId;
    },
    formatCommentStatus(status) {
      const labels = {
        PENDING: "Pending",
        APPROVED: "Approved",
        REJECTED: "Rejected",
      };
      const normalizedStatus = String(status || "").toUpperCase();
      return labels[normalizedStatus] || status;
    },
    commentStatusClass(status) {
      return `comment-status--${String(status || "").toLowerCase()}`;
    },
    formatCommentDate(date) {
      return moment.parseZone(date).format("DD/MM/YYYY hh:mm A");
    },
    async moderateComment(comment, status) {
      if (this.moderatingCommentId !== null || this.isLoadingComments) {
        return;
      }

      this.moderatingCommentId = comment.comment_id;
      const formData = new FormData();
      formData.append("status", status);

      try {
        const response = await axios.put(
            `${this.domain}/v2/event_and_tips/admin/${this.$route.params.id}/comments/${comment.comment_id}`,
            formData,
            {
              headers: {
                Authorization: this.token,
              },
              transformRequest: [(data, headers) => {
                // Let the browser add the multipart boundary for FormData.
                if (headers.put) {
                  delete headers.put["Content-Type"];
                }
                delete headers["Content-Type"];
                return data;
              }],
            }
        );
        const responseBody = response.data || {};
        const updatedComment = responseBody.data && !Array.isArray(responseBody.data)
            ? responseBody.data
            : responseBody;

        this.comments = this.comments.map((currentComment) =>
          currentComment.comment_id === updatedComment.comment_id
              ? updatedComment
              : currentComment
        );
        this.commentActionMenuId = null;
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response?.data?.desc?.id || err.message,
        });
      } finally {
        this.moderatingCommentId = null;
      }
    },
    async handleCorporateActionSubPhotoUrl(event) {
      const file = event[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file, true)
      this.subPhotoUrl = dataUrl
      this.error.attachment_corporate_action_sub_photo_url.message = err
      this.corporateActionData.attachment_corporate_action_sub_photo_url = event[0];
    },
    async readURL(e) {
      const file = e[0];
      const {dataUrl, err} = await validateImageHeightAndWidth(file)
      this.url = dataUrl
      this.error.attachment_corporate_action_photo_url.message = err
      this.corporateActionDataNew.attachment_corporate_action_photo_url = e[0];
    },
    updateCorporateAction() {
      if (this.isSubmitting) {
        return;
      }

      const semuaCategory = this.articleSemuaCategory || this.optionsArticleCategories.find(
          category => category.name === "Semua"
      ) || this.selectedArticleCategories.find(category => category && category.name === "Semua");
      if (
          !semuaCategory ||
          semuaCategory.id === undefined ||
          semuaCategory.id === null ||
          semuaCategory.id === ""
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Category Semua tidak dapat diubah"
        });
        return;
      }

      const selectedArticleCategories = Array.isArray(this.selectedArticleCategories)
          ? this.selectedArticleCategories
          : [];
      const articleCategoryIDs = selectedArticleCategories
          .filter(category => category && category.id !== undefined && category.id !== null && category.id !== "")
          .map(category => category.id);

      if (
          this.corporateActionData.attachment_corporate_action_photo_url["size"] >
          250000
      ) {

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture too big. Please upload below 250 KB",
        });
        return;
      } else {
        if (this.error.attachment_corporate_action_photo_url.message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.error.attachment_corporate_action_photo_url.message,
          });
          return;
        }
      }

      if (this.corporateActionData.attachment_corporate_action_sub_photo_url['size'] > 150000) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Picture too big. Please upload below 150 KB"
        });
        return;
      }
      if (this.error.attachment_corporate_action_sub_photo_url.message) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: this.error.attachment_corporate_action_sub_photo_url.message
        });
        return;
      }
// --- VALIDASI PRIORITY ---
      if (this.corporateActionData.is_suggested === "YES" &&
          this.corporateActionData.article_info !== "NEWS") {

        if (!this.corporateActionData.priority) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Priority wajib diisi jika suggested."
          });
          return;
        }

        const p = Number(this.corporateActionData.priority);
        if (p < 1 || p > 5) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Priority hanya boleh 1 sampai 5."
          });
          return;
        }
      }
      if (this.faqs && this.faqs.length > 6) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Maksimal 6 data FAQ."
        });
        return;
      }

      if (this.faqs && this.faqs.length > 0) {
        for (let i = 0; i < this.faqs.length; i++) {
          const item = this.faqs[i];
          const p = Number(item.priority);
          if (item.priority === "" || item.priority === null || isNaN(p) || p < 0) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Priority FAQ ke-${i + 1} harus berupa angka non-negatif.`
            });
            return;
          }
          if (!item.question || !item.question.trim()) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Pertanyaan FAQ ke-${i + 1} harus diisi.`
            });
            return;
          }
          if (item.question.trim().length > 255) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Pertanyaan FAQ ke-${i + 1} maksimal 255 karakter.`
            });
            return;
          }
          if (!item.answer || !item.answer.trim()) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Jawaban FAQ ke-${i + 1} harus diisi.`
            });
            return;
          }
        }
      }

      var activeDate = moment(
        this.corporateActionDataNew.active_date,
        "YYYY-MM-DDTHH:mm"
      ).format("YYYY-MM-DDTHH:mm:ssZ");
      this.corporateActionData.corporate_action_author = this.corporateActionDataNew.corporate_action_author;
      let CorporateActionID = this.$route.params.id;
      let formData = new FormData();
      formData.append(
          "corporate_action_title",
          this.corporateActionData.corporate_action_title
      );
      formData.append(
          "corporate_action_slug",
          this.corporateActionData.corporate_action_slug
      );
      formData.append(
          "corporate_action_type",
          this.corporateActionData.corporate_action_type
      );
      formData.append(
          "corporate_action_author",
          this.author ? this.author.author_name : ""
      );
      formData.append(
          "corporate_action_author_id",
          this.author ? this.author.author_id : ""
      );
      formData.append("active_date", activeDate);
      formData.append(
          "corporate_action_content",
          this.corporateActionData.corporate_action_content
      );
      formData.append(
          "attachment_corporate_action_photo_url",
          this.corporateActionData.attachment_corporate_action_photo_url
      );
      if (this.corporateActionData.is_suggested === "YES" &&
          this.corporateActionData.article_info !== "NEWS") {
        formData.append("priority", this.corporateActionData.priority);
      }

      formData.append("alt_photo", this.corporateActionData.alt_photo);
      formData.append(
          "attachment_corporate_action_sub_photo_url",
          this.corporateActionData.attachment_corporate_action_sub_photo_url
      );
      formData.append("alt_sub_photo", this.corporateActionData.alt_sub_photo);
      formData.append("status", this.corporateActionData.status);
      formData.append(
          "corporate_action_hashtag_ids",
          this.corporateActionData.corporate_action_hashtag_ids + ','
      );
      formData.append("corporate_action_article_category_ids", articleCategoryIDs.join(","));
      formData.append(
          "corporate_action_related_show_option",
          this.corporateActionData.corporate_action_related_show_option
      );
      formData.append("article_info", this.corporateActionData.article_info);
      formData.append("is_suggested", this.corporateActionData.is_suggested === "YES" ? true : false);
      formData.append("meta_info_keyword", this.corporateActionData.meta_info_keyword);
      formData.append("meta_info_description", this.corporateActionData.meta_info_description);
      formData.append("show_pos_interpack", this.corporateActionData.show_pos_interpack);
      formData.append("corporate_action_category_id", this.corporateActionData.corporate_action_category_id);
      formData.append("language", this.corporateActionData.language);
      formData.append("faq_status", this.corporateActionDataNew.faq_status || "ACTIVE");
      if (this.faqs && this.faqs.length > 0) {
        this.faqs.forEach((item, i) => {
          formData.append(`faq_priority[${i}]`, item.priority);
          formData.append(`faq_question[${i}]`, item.question.trim());
          formData.append(`faq_answer[${i}]`, item.answer.trim());
        });
      }
      formData.append("like_enabled", this.likeCommentSelection.includes("Like") ? "true" : "false");
      formData.append("comment_enabled", this.likeCommentSelection.includes("Comment") ? "true" : "false");
      this.isSubmitting = true;
      axios
          .put(
              `${this.domain}/v2/event_and_tips/admin/${CorporateActionID}`,
              formData,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Corporate Action Data Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.items = response.data.data;
            this.$router.push({ path: `/management/corporate` });
          })
          .catch((err) => {
            this.isSubmitting = false;
            this.corporateActionDataNew.active_date = moment(
                String(this.corporateActionDataNew.active_date)
            ).format("YYYY-MM-DDTHH:mm");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                err &&
                err.response &&
                err.response.data &&
                err.response.data.desc &&
                err.response.data.desc.id
                  ? err.response.data.desc.id
                  : "Terjadi kesalahan saat memperbarui data",
            });
          });
    },
  },
  validator(val) {
    return val ? val.length >= 4 : false;
  },
};
</script>

<style scoped>
@import "./Corporate.css";

.comment-list-card-body {
  border-top: 1px solid #e0e0e0;
}

.comment-text {
  min-width: 220px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.comment-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  border-radius: 1rem;
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.comment-status::before {
  content: "";
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: currentColor;
}

.comment-status--pending {
  color: #856404;
  background: #fff3cd;
}

.comment-status--approved {
  color: #155724;
  background: #d4edda;
}

.comment-status--rejected {
  color: #721c24;
  background: #f8d7da;
}

.comment-action {
  position: relative;
  display: inline-block;
}

.comment-action-toggle {
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  color: #495057;
  background: #fff;
}

.comment-action-toggle:disabled,
.comment-action-menu button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.comment-action-menu {
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  z-index: 10;
  min-width: 8rem;
  padding: 0.25rem 0;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.12);
}

.comment-action-menu button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.4rem 0.75rem;
  border: 0;
  color: #212529;
  background: transparent;
  text-align: left;
}

.comment-action-menu button:hover:not(:disabled) {
  background: #f8f9fa;
}

.comment-action-icon {
  margin-right: 0.5rem;
}

.comment-action-icon--approve {
  color: #28a745;
}

.comment-action-icon--reject {
  color: #dc3545;
}

.comment-pagination-nav button {
  color: inherit;
}

.comment-pagination-nav button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
